$(function(){
	$('.popup').on('click', function(e){
		var targetEl = $(e.target);
		var popupEl  = targetEl.closest('.popup');

		// hide if click ouside modal container
		if(!targetEl.is('[data-popup-container]') && targetEl.parents('[data-popup-container]').length <= 0) closePopup(popupEl);
	});
});

window.openPopup = function(popup) {
	var popupEl = null;

	// if passed jquery object
  if(popup instanceof jQuery && popup.length > 0) popupEl = popup;
  // if passed js element
  else if(popup instanceof Element) popupEl = $(popup);
  // if passed string
	else popupEl = $('[data-popup="' + popup + '"]');
	
	// disable body scroll
	// if(popupEl.length > 0) {
	// 	$('body, html').css('overflow-y', 'hidden');
	// }

	popupEl.show();
}

window.closePopup = function(popup) {
	var popupEl = null;

	// if passed jquery object
  if(popup instanceof jQuery && popup.length > 0) popupEl = popup;
  // if passed js element
  else if(popup instanceof Element) popupEl = $(popup);
  // if passed string
  else popupEl = $('[data-popup="' + popup + '"]');
	
	// enable body scroll
	// $('body, html').css('overflow-y', 'auto');

	popupEl.hide();
}